import {IToastService} from "../services/ToastService";
import {LTMap} from "../lt-ng/lt-directives";
import {Download, IQueueResponse, IQueueService} from "../services/queue";
import {MapFishPrint, MapFishPrint as MPF} from "../utility/map-fish-print";
import {LTServices} from "../lt-ng/lt-services";
import {L} from "../lt-ng/landcare-toolkit";
import {IAppConfig} from "../services/app-config/app_config";
import {FeaturesLayer} from "../services/features-api/features-layer";
import {FeaturesEvents} from "../services/events/FeaturesEvents";
import {Map as OlMap, MapEvent} from "ol";
import Feature from "ol/Feature";
import {Geometry, Point} from "ol/geom";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Coordinate} from "ol/coordinate";
import {Extent, getHeight, getWidth} from "ol/extent";
import {fromExtent} from "ol/geom/Polygon";
import {Translate} from "ol/interaction";
import {GeoAppEvents} from "./events/geoapp_events";
import {pageExtent} from "../utility/print/page";
import IQueryString = LTMap.IQueryString;
import INameValue = MapFishPrint.INameValue;
import IName = MapFishPrint.IName;
import IPrintCapabilities = MapFishPrint.IPrintCapabilities;
import IMapService = LTServices.IMapService;
import getVisibleLayers = L.tree.getVisibleLayers;
import IMapFishRequest = MapFishPrint.IMapFishRequest;
import ILayout = MapFishPrint.ILayout;
import Item = L.tree.Item;
import someNodes = L.tree.someNodes;
import Messages from "../components/svelte/Messages.svelte";

/**
 * Created by tom on 3/03/17.
 */

interface IPrintEvent {
	category: string;
	layout: string;
	scale: string;
	event?: string;
}

const NOT_FOUND = 'Task with given id could not be found!';

type Message = {
	message: string;
	time: string;
	level?: "warning"|"success"|"error"
};

export interface IPrintScope extends ng.IScope {
	Messages: any;
	messagesProps: {
		messages: Message[],
		showDismiss: boolean;
	};
	messagesCallbacks: {
		dismiss?: (ev: CustomEvent) => void;
	};
	customLayersExcluded: boolean;
	layouts : MPF.ILayout[];
	mapTitle : { text : string };
	scales : MPF.INameValue[];
	formats: { name : string }[];
	zoomToScale : (scale : number) => void;
	loading: boolean;
	loadingCapabilities: boolean;
	updatePageFeature();
	doPrint();
	close();
	selection : {
		layout : MPF.ILayout;
		scale : INameValue;
		format : IName;
		featureOption?: INameValue;
	};
	getSelectedScale(): INameValue
	featureOptions: INameValue[];
	printCapabilities : ng.IHttpPromise<IPrintCapabilities>;
	currentScale: number;
	processingLegend: boolean;
	problemLayers: string[];
	layerFilter: (Item) => boolean;
	getPrintEvent: () => IPrintEvent;
	anyFeatures(): boolean;
	requestTooLarge: boolean;
	updateFeaturesOption();
	printProgress(): number
    downloadLink: Download;
}


export interface IPrintService {
	appName : string;
	capabilities () : ng.IHttpPromise<IPrintCapabilities>;
	fixPrintURL(url: string) : string;
	getTitle(title: string): string;
}

export class PrintService implements IPrintService {
	public appName = 'smap';
	// protected printModuleUrl = '/print_module/';
	protected printModuleUrl = '/services/print/';
	protected printCapabilitiesUrl = null;

	public static $inject = ['$http', 'appConfig'];
	constructor(protected $http : ng.IHttpService, protected appConfig: IAppConfig) {
		this.printModuleUrl = L.util.Layer.realUrlOffset(this.printModuleUrl);
		this.appName = appConfig.printModuleApplication();
		this.printCapabilitiesUrl = `${this.printModuleUrl}pdf/info.json?var=printCapabilities&app=${this.appName}`;
	}

	getTitle(title: string): string {
		return `${this.appConfig.getApplication()} - ${title || 'Print'}`;
	}

	capabilities(): ng.IHttpPromise<MapFishPrint.IPrintCapabilities> {
		return this.$http.get<IPrintCapabilities>(this.printCapabilitiesUrl, {
			cache: true,
			transformResponse : (data, headersGetter, status) => {
				if (status >= 200 && status < 300) {
					let cutoff = data.indexOf('=');
					if (cutoff != -1) data = data.substring(cutoff + 1, data.length - 1);
					let json = <MapFishPrint.IPrintCapabilities> JSON.parse(data);
					json.createURL = this.fixPrintURL(json.createURL);
					json.printURL = this.fixPrintURL(json.printURL);

					/*let a2Portrait: ILayout = {
						name: "A2 Portrait",
						rotation: false,
						map: {

						}
					}*/

					json.layouts.push(

					)

					return JSON.parse(data);
				}
				return data;
			}
		});
	}


	fixPrintURL(url: string): string {
		return this.printModuleUrl + url.substring(url.indexOf('pdf/'));
	}
}

export class PrintCtrl {
	public static $inject = ['$scope', '$http', '$interval', 'landcareMapService', 'toastService', 'queueService',  'myQueryString.QueryString', 'printService'];
	constructor(
			protected $scope: IPrintScope,
			protected $http : ng.IHttpService,
			protected $interval : ng.IIntervalService,
			protected mapService: IMapService,
			protected toastService : IToastService,
			protected queueService : IQueueService,
			protected queryString: IQueryString,
			protected printService: IPrintService) {
		$scope.Messages = Messages;
		$scope.messagesProps = {
			messages: [],
			showDismiss: false
		}

		const inchesPerMetre = 1000 / 25.4;
		const dpi = 72;

		function millimetresToMapUnits(val : number, scale : number = 1) : number {
			return val / dpi / inchesPerMetre * scale;
		}

		let startedAt: number;
		function estimateTime(width: number, height: number, scale): number {
			const a = width / dpi / inchesPerMetre;
			const b = height / dpi / inchesPerMetre;
			const area = a * b * scale;

			/**
			 * Linear regression variables derived from the 'Area km2' and Duration columns from these observations
			 *
			 * Start, End, and Duration arein seconds
			 * Scale - 1:8,000,000 => 1.25E-07
			 *
			 * Paper Size    Scale    Layer    Start    End    Paper area    Scale    Area km2    Duration
			 * A4 Portrait    1:8M    Vegetation    43.45    81.6    0.042675890354938    1.25E-07    341407.122839506    38.15
			 * A4 Landscape    1:8M    Vegetation    131.4    165    0.042021520895062    1.25E-07    336172.167160494    33.6
			 * A3 Portrait    1:8M    Vegetation    185.4    226.8    0.088276406481482    1.25E-07    706211.251851852    41.4
			 * A3 Landscape    1:8M    Vegetation    264.6    300    0.08124237037037    1.25E-07    649938.962962963    35.4
			 * A4 Portrait    1:4M    Vegetation    326.4    354    0.042675890354938    2.5E-07    170703.561419753    27.6
			 * A4 Landscape    1:4M    Vegetation    391.8    414    0.042021520895062    2.5E-07    168086.083580247    22.2
			 * A3 Portrait    1:4M    Vegetation    450    495.6    0.088276406481482    2.5E-07    353105.625925926    45.6
			 * A3 Landscape    1:4M    Vegetation    531    558.6    0.08124237037037    2.5E-07    324969.481481481    27.6
			 * A4 Portrait    1:2M    Vegetation    582.6    600    0.042675890354938    5E-07    85351.7807098765    17.4
			 * A4 Landscape    1:2M    Vegetation    622.2    637.8    0.042021520895062    5E-07    84043.0417901235    15.6000000000001
			 * A3 Portrait    1:2M    Vegetation    659.4    680.4    0.088276406481482    5E-07    176552.812962963    21
			 * A3 Landscape    1:2M    Vegetation    715.2    732    0.08124237037037    5E-07    162484.740740741    16.8
			 * A4 Portrait    1:1M    Vegetation    754.2    762.6    0.042675890354938    1E-06    42675.8903549383    8.39999999999998
			 * A4 Landscape    1:1M    Vegetation    796.8    805.2    0.042021520895062    1E-06    42021.5208950617    8.40000000000009
			 * A3 Portrait    1:1M    Vegetation    849.6    862.2    0.088276406481482    1E-06    88276.4064814815    12.5999999999999
			 * A3 Landscape    1:1M    Vegetation    877.2    888    0.08124237037037    1E-06    81242.3703703704    10.8000000000001
			 * A4 Portrait    1:500k    Vegetation    957.6    964.8    0.042675890354938    2E-06    21337.9451774691    7.19999999999993
			 * A4 Landscape    1:500k    Vegetation    1011.6    1018.2    0.042021520895062    2E-06    21010.7604475309    6.60000000000002
			 * A3 Portrait    1:500k    Vegetation    1052.4    1063.8    0.088276406481482    2E-06    44138.2032407407    11.4000000000001
			 * A3 Landscape    1:500k    Vegetation    1101.6    1111.8    0.08124237037037    2E-06    40621.1851851852    10.2000000000003
			 *
			 *
			 *    Area m2
			 * A4 Portrait    0.042675890354938    530    0.186972222222222    647    0.228247222222222
			 * A4 Landscape    0.042021520895062    778    0.274461111111111    434    0.153105555555556
			 * A3 Portrait    0.088276406481482    771    0.271991666666667    920    0.324555555555556
			 * A3 Landscape    0.08124237037037    1088    0.383822222222222    600    0.211666666666667
			 */

			return (0.00005403919404 * area + 10.25083062);
		}


		let printCapabilities : IPrintCapabilities = null;
		let queueTask : IQueueResponse = null;
		$scope.loadingCapabilities = true;
		// setup defaults
		$scope.loading = false;
		$scope.mapTitle = { text : '' };
		$scope.layouts = [];
		$scope.scales = [];
		$scope.formats = [];

		const onlySelected : INameValue = {
			name: "Only the selected feature(s)",
			value: "SELECTED"
		};

		const allPins: INameValue = {
			name: "All of the pins",
			value: "PINS"
		};

		const noFeatures: INameValue = {
			name: "No features",
			value: "NONE"
		};

		type FeaturePredicate = (f: Feature<Geometry>) => boolean;
		const getFeatureFilter: () => FeaturePredicate = () => {
			if ($scope.selection.featureOption == allPins) {
				return (f) => {
					return f.getGeometry() instanceof Point;
				}
			} else if ($scope.selection.featureOption == onlySelected) {
				return (f) => {
					return f.get('selected');
				}
			}
			return () => false;
		};

		$scope.selection = {
			layout	: null,
			scale	: null,
			format	: null,
			featureOption: noFeatures
		};

		$scope.requestTooLarge = false;

		const savedFeatureSource = new VectorSource();
		const savedFeatureLayer = new FeaturesLayer({
			source: savedFeatureSource,
			zIndex: 10000
		});

		$scope.updateFeaturesOption = () => {
			savedFeatureSource.clear();
			const features = mapService.featuresLayer.getSource().getFeatures().filter(getFeatureFilter());
			savedFeatureSource.addFeatures(features);
		};

		const updateFeatureOptions = () => {
			const anySelected = mapService.featuresLayer.getSource().getFeatures().some(f => f.get('selected'));
			$scope.selection.featureOption = anySelected ? onlySelected : noFeatures;
			$scope.featureOptions = anySelected ? [onlySelected, allPins, noFeatures] : [allPins, noFeatures];
			$scope.updateFeaturesOption();
		};

		$scope.anyFeatures = () => mapService.featuresLayer.getSource().getFeatures().length > 0;

		updateFeatureOptions();
		$scope.$on(FeaturesEvents.reportChanged, updateFeatureOptions);
		mapService.featuresLayer.getSource().on('change', updateFeatureOptions);

		$scope.problemLayers = [];

		$scope.getPrintEvent = () => {
			const selection = $scope.selection;
			const scaleObj = selection && selection.scale;
			const theScale = scaleObj && scaleObj.value || "null";
			const theLayout = selection && selection.layout && selection.layout.name || 'null';
			const printEvent: IPrintEvent = {
				scale: theScale,
				"category": "PRINT_MAP",
				"layout": theLayout,
				"event": 'submit'
			};
			return printEvent;
		};

		$scope.$watch('selection.scale', (scaleObj : MPF.INameValue) => {
			$scope.problemLayers = [];
			let theScale = scaleObj && Number(scaleObj.value);
			if (!theScale) return;

			let visibleLayers = getVisibleLayers(mapService.treeData).filter((n) => n.layerService);

			let zoomedInTooMuch = visibleLayers
				.filter((n) => theScale < n.layerService.minScale);

			let zoomedOutTooMuch = visibleLayers
				.filter((node) => node.layerService.maxScale && theScale > node.layerService.maxScale);

			$scope.problemLayers = zoomedInTooMuch.concat(zoomedOutTooMuch).map((n) => n.name);
		});

		let setCustomLayersExcluded = () => {
			$scope.customLayersExcluded = someNodes(mapService.treeData || [], (n) => n.isCustom && n.checked);
		};

		$scope.$on('onTreeChange', setCustomLayersExcluded);
		setCustomLayersExcluded();

		$scope.printCapabilities = printService.capabilities();

		$scope.printCapabilities.then((resp) => {
			$scope.loadingCapabilities = false;
			// configure the view with the response from the print server

			printCapabilities = resp.data;
			const selection = $scope.selection;

			// use A4 Portrait by default
			let a4 = printCapabilities.layouts.filter((layout) => layout.name == 'A4 Portrait');
			selection.layout = a4.length ? a4[0] : printCapabilities.layouts[printCapabilities.layouts.length - 1];

			let mapScales = $scope.$parent['scales'];
			if (map && mapScales && mapScales.length) {
				// try to choose an appropriate scale for the current zoom level
				let view = map.getView();
				let zoom = view.getZoom();
				let scale = zoom > 0 && zoom < mapScales.length ? mapScales[zoom] : NaN;
				if (!isNaN(scale)) {
					let candidates = printCapabilities.scales.filter((it) => parseInt(it.value) < scale);
					$scope.selection.scale = printCapabilities.scales[candidates.length-1];
				}
			}

			if (!selection.scale) {
				// default to just choosing the first scale in the list
				selection.scale  = printCapabilities.scales[printCapabilities.scales.length - 1];
			}

			// use pdf as the default format
			let formats = printCapabilities.outputFormats;
			let jpgLike = formats.filter((f) => f.name == 'jpg' || f.name == 'jpeg');
			if (jpgLike.length > 1) {
				formats = formats.filter((f) => f.name != 'jpg');
			}
			$scope.formats = formats;
			let pdf = $scope.formats.filter((f) => f.name == 'pdf');
			selection.format = (!selection.format && pdf.length) ? pdf[0] : null;

			$scope.scales = printCapabilities.scales;
			$scope.layouts = printCapabilities.layouts;

			// $scope.updatePageFeature();
			return resp.data;
		}, (err) => {
			console.error('printCapabilities error');
			console.error(err);
		});


		let map : OlMap = null;
		const pageSrc = new VectorSource();
		const pageFeatureLayer = new VectorLayer({
			source : pageSrc,
			zIndex: 9001
		});

		let pageFeatureCenter : Coordinate = null;
		let pageFeature = new Feature();
		pageSrc.addFeature(pageFeature);

		$scope.zoomToScale = (scale: number) => {
			console.log('scale', scale);
			$scope.currentScale = scale;
		};

		function mapCanContainPage(layout : ILayout, scale : number, mapExtent : Extent) {
			let mW = getWidth(mapExtent);
			let pW = millimetresToMapUnits(layout.map.width, scale);
			if (pW > mW) return false;

			let mH = getHeight(mapExtent);
			let pH = millimetresToMapUnits(layout.map.height, scale);
			return pH <= mH;
		}

		/**
		 * Return null is no suitable scale is found.
		 * @param {MapFishPrint.ILayout} layout
		 * @param {Extent} mapExtent
		 * @param {MapFishPrint.INameValue[]} scales
		 * @returns INameValue
		 */
		function pageScaleThatFitInMap(layout : ILayout, mapExtent : Extent, scales : MPF.INameValue[]) : INameValue {
			let scale : INameValue = null;
			for(let idx=scales.length-1; idx>=0; idx--) {
				scale = scales[idx];
				if (mapCanContainPage(layout, parseInt(scale.value), mapExtent)) {
					return scale;
				}
			}

			return scale;
		}

		let disableOnMapMove=false;

		let updateOnZoom = (moveOnly : boolean = false) => {
			let pageGeom = pageFeature.getGeometry();
			if(!pageGeom) return;

			console.log('map-zoom-change');
			if (!map || !$scope.scales.length) return;
			let view = map.getView();
			let mapExtent = view.calculateExtent(map.getSize());


			if (!moveOnly) {
				let mW = getWidth(mapExtent);
				if (mW <= 0) {
					return;
				}
				let pageExtent  = pageGeom.getExtent();
				let pW = getWidth(pageExtent);

				// we want to change the size of the page geometry
				// because the map has been zoomed.
				if (!mapCanContainPage($scope.selection.layout, parseInt($scope.selection.scale.value), mapExtent)) {
					let newScale = pageScaleThatFitInMap($scope.selection.layout, mapExtent, $scope.scales);
					if (newScale) {
						$scope.selection.scale = newScale;
						disableOnMapMove = true;
						while (view.getZoom() > 0 && !mapCanContainPage($scope.selection.layout, parseInt($scope.selection.scale.value), mapExtent)) {
							view.setZoom(view.getZoom() - 1);
							mapExtent = view.calculateExtent(map.getSize());
						}
						disableOnMapMove = false;
					}
				} else if (mW > pW * 4) {
					// move to a larger scale
					let idx = $scope.scales.indexOf($scope.selection.scale) + 1;
					if (idx < $scope.scales.length) {
						$scope.selection.scale = $scope.scales[idx];
					}
				}
			}
			pageFeatureCenter = null; // this will cause the page to be centred on the screen
			$scope.updatePageFeature();
		};

		$scope.printCapabilities.then(() => {
			$scope.updatePageFeature();
			updateOnZoom();
		});

		let lastZoom = -1;

		$scope.$on('map-move', (ev, olEvent : MapEvent) => {
			// because the 'map-zoom-change' event is triggered by open layers,
			// we probably need to $apply to effect the $scope
			if(disableOnMapMove) return;
			let z = olEvent.map.getView().getZoom();
			if ($scope.$$phase) {
				updateOnZoom(lastZoom == z);
			} else {
				$scope.$apply(() => updateOnZoom(lastZoom == z));
			}
			lastZoom = z;
		});


		$scope.$watch('selection', () => {
			/*if ($scope.selection.scale) {
				$scope.zoomToScale(parseInt($scope.selection.scale));
			}*/
			$scope.updatePageFeature();

		});


		$scope.close = () => {
			if (!$scope.loading || confirm("Leaving now will cancel your map download.")) {
				$scope.$root.$broadcast(GeoAppEvents.closePrint);
				if (map) map.setTarget(null); // detach the map from its DOM element
				if (queueTask) {
					// cancel the job...
					this.queueService.action('cancel', [queueTask.queueTaskId], queueTask.queueName);
				}
			}
		};

		$scope.printProgress = () => {
			const layout = $scope.selection && $scope.selection.layout;
			const scale = $scope.selection && $scope.selection.scale && $scope.selection.scale.value;

			if (!layout || !scale) {
				return 0;
			}

			const estimatedTime = estimateTime(layout.map.width, layout.map.height, parseInt(scale));

			if (!startedAt || !estimatedTime) {
				return 0;
			}

			return Math.min(
				Math.max(
					Math.round(100 * ((Date.now() - startedAt) / 1000) / estimatedTime),
					1
				),
				98 // Don't show we've completed the map before it is ready
			);
		}

		$scope.updatePageFeature = () => {
			console.log('updatePageFeature');
			if (map == null ||
				!$scope.scales.length ||
				!$scope.layouts.length) {
				return;
			}

			if (pageFeatureCenter == null) {
				pageFeatureCenter = map.getView().getCenter();
			} else {
				let geom = pageFeature.getGeometry();
				let extent = geom.getExtent();
				pageFeatureCenter = [(extent[0] + extent[2]) / 2.0, (extent[1] + extent[3]) / 2];
			}

			let selectedScale = $scope.selection.scale;
			let scale = parseInt(selectedScale.value);

			let layout = $scope.selection.layout;

			pageFeature.setGeometry(fromExtent(pageExtent(
				pageFeatureCenter, scale, layout
			)));
		};

		let initMap = (aMap : OlMap) => {
			// Uncomment below if you want to include area report's polygons in printouts.
			// Also look at map-fish-print.ts and enable vector layer encoding
			aMap.addLayer(savedFeatureLayer);
			aMap.addLayer(pageFeatureLayer);

			let movePage = new Translate({
				features : pageSrc.getFeaturesCollection(),
				layers: [pageFeatureLayer],
			});
			aMap.addInteraction(movePage);
			aMap.updateSize();
			window.requestAnimationFrame(() => {
				aMap.updateSize();
			});

			$scope.updatePageFeature();

			$scope.updateFeaturesOption();
		};

		$scope.layerFilter = (i: Item) => !i.isCustom;

		// when a child scope notifies us of a map
		$scope.$on('ol-map', (ev, eventMap : OlMap) => {
			if (eventMap != null && eventMap != map) {
				initMap(eventMap);
			}
			map = eventMap;
			console.log(map);
		});

		// ask child scopes for a map;
		$scope.$broadcast('ol-get-map');

		let getCentre = (geometry : Geometry) : Coordinate => {
			// make the assumption that this is just a rectangle...
			let extent = geometry.getExtent();
			return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
		};

		function clearMessages() {
			$scope.messagesProps = { ...$scope.messagesProps, messages: [] };
		}

		$scope.messagesCallbacks = {
			dismiss() {
				clearMessages();
			}
		};

		function addMessage(message: Message) {
			const messages = [
				...$scope.messagesProps.messages,
				message
			];
			$scope.messagesProps = {
				...$scope.messagesProps,
				messages
			};
		}

		$scope.doPrint = () => {
            $scope.downloadLink = undefined;
			const byClassesOrConfigurationUrl = '/services/portal_configuration/layer_configuration_class';
			const queryItems = getVisibleLayers(this.mapService.treeData)
				.filter((n) => !n || !n.isCustom && !n.isLocalData)
				.filter((n) => n.classId || n.layerId)
				.filter(n => {
					if (!n.classId) return true;

					return !n.parent.isLocalData && !n.parent.isCustom;
				})
				.map((n) => {
					return {
						'type': (n.classId ? 'class' : 'configuration'),
						'id': (n.classId ? n.classId : n.layerId)
					};
			});
			if (!queryItems.length) {
				console.warn('no layer nodes selected');
				return;
			}
			$scope.processingLegend = true;
			$scope.requestTooLarge = false;

			const onError = (err : any, msg?: string) => {
				$scope.messagesProps = {
					...$scope.messagesProps,
					showDismiss: true
				}
				this.toastService.showToast(msg || 'PRINT ERROR');
				console.error(err);
				$scope.loading = false;
			};

			const printConfiguration : ng.IPromise<IMapFishRequest> = $http({
				url: byClassesOrConfigurationUrl,
				method: 'POST',
				data: {
					request: {
						items: queryItems
					}
				},
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then((response) => {
				const classConfigurations = response.data['response'];

				try {
					return MapFishPrint.layerTreeToRequest(
						this.mapService.treeData,
						map,
						$scope.mapTitle.text,
						this.printService.appName,
						$scope.selection.layout,
						$scope.selection.format.name,
						getCentre(pageFeature.getGeometry()),
						$scope.selection.scale,
						this.queryString,
						classConfigurations, // uncomment if including area report polygons
						[mapService.featuresLayer],
						getFeatureFilter()
					);
				} catch (e) {
					$scope.requestTooLarge = true;
					onError(e, 'Request too large');
				}
			});

			$scope.loading = true;

			const onFinish = (data : IQueueResponse) => {
				// console.log('onFinish', data);
				queueService.download(data.queueTaskId, data.queueName).then((response: any) => {
					// window.location.replace(this.printService.fixPrintURL(response.data.getURL));
					const p = queueService.downloadUntilThere(
						this.printService.fixPrintURL(response.data.getURL),
						this.printService.getTitle($scope.mapTitle.text),
					);
					p.catch((err) => {
						throw new Error(err);
					});
					p.then((anchor) => {
						queueTask = null; // ensure no invalid cancellations!
                        $scope.downloadLink = anchor;
					});
					$scope.loading = false;
				}, () => { $scope.loading = false; });
			};

			let numberOfErrors = 0;
			const errorLimit = 3;
			let firstResponse;

			const initialQueueResponse = printConfiguration.then((config : IMapFishRequest) => {
				console.log(JSON.stringify(config));
				firstResponse = true;
				$scope.messagesProps = {
					...$scope.messagesProps,
					showDismiss: false
				}
				clearMessages();
				addMessage({
					message: "Queueing",
					time: (new Date()).toLocaleTimeString(),
					level: "warning"
				});
				startedAt = Date.now();

				return this.queueService
					.enqueue(printCapabilities.createURL, 'print-map', { spec : JSON.stringify(config)});
			});

			const afterInitial = (result) => {
				queueTask = result.data;
				console.log(result.data);
				const queryStatus = () => {
					const queryAgain = this.queueService
						.action('status', [result.data.queueTaskId], result.data.queueName);

					queryAgain.then((response) => {
						if (!response.data.length) return;

						const data = response.data[0];

						switch (data.status) {
							case 'CANCELLED':
								addMessage({
									message: "Print task cancelled",
									time: (new Date()).toLocaleTimeString(),
									level: "warning"
								});
								$scope.messagesProps = {
									...$scope.messagesProps,
									showDismiss: true
								}
								break;
							case 'FINISHED':
								$scope.messagesProps = {
									...$scope.messagesProps,
									showDismiss: true
								}
								addMessage({
									message: "Finished. Starting download",
									time: (new Date()).toLocaleTimeString(),
									level: "success"
								});
								onFinish(data);
								break;
							case 'ERROR':
								console.log('print error data', data);

								addMessage({
									message: "Print failed with unexpected error!",
									time: (new Date()).toLocaleTimeString(),
									level: "error"
								});

								if (data.error === NOT_FOUND) {
									setTimeout(() => afterInitial(result), 1000);
									return;
								} else {
									onError(data);
								}
								break;
							default:
								if (firstResponse) {
									addMessage({
										message: "Task queued",
										time: (new Date()).toLocaleTimeString()
									});
								} else {
									addMessage({
										message: "In progress",
										time: (new Date()).toLocaleTimeString()
									});
								}
								window.setTimeout(queryStatus, 2000);
						}
						firstResponse = false;
					}, (reason) => {
						numberOfErrors++;
						if (numberOfErrors < errorLimit) {
							addMessage({
								message: "Retrying",
								time: (new Date()).toLocaleTimeString(),
								level: "warning"
							});
							printConfiguration.then((config : IMapFishRequest) => {
								this.queueService
									.enqueue(printCapabilities.createURL, 'print-map', { spec : JSON.stringify(config)})
									.then(afterInitial);
							});

						} else {
							onError(reason);
						}
					});
				};

				queryStatus();
			};
			initialQueueResponse.then(afterInitial);
		};
	}
}
